import { render, staticRenderFns } from "./mpermission.vue?vue&type=template&id=925a1dd8&scoped=true&"
import script from "./mpermission.vue?vue&type=script&lang=js&"
export * from "./mpermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925a1dd8",
  null
  
)

export default component.exports